import { useTokenValidation } from '~/composables/useTokenValidation'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const app = useAppStore()
  const { validateTokens, clear } = useTokenValidation()

  router.beforeEach(async (to, from) => {
    if (to.path === '/auth/') {
      console.log('token-cleaner', router.currentRoute.value.path)
      clear()
    }
  })
})
